export default __webpack_public_path__ + "static/media/balance-mir.176a4d53.svg";